import { BLOG_TOPICS, blogPath } from '../../lib/blogTopics';
import { blogImages, blogText, blogExcerpt, subscribeBlogUpdates } from '../../lib/blogData';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import supabase from "../../lib/supabaseClient";
import useTranslate from "../../hooks/useTranslate";
import "./LatestPosts.scss";

export default function LatestPosts() {
  const { translate, language } = useTranslate();
  const isFa = language.startsWith("fa");
  const [posts, setPosts] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let active = true;
    let request = 0;
    async function loadPosts() {
      const current = ++request;
      try {
        const results = await Promise.all(BLOG_TOPICS.map(topic => supabase
          .from('blogs').select('id,slug,topic,title_fa,title_en,description_fa,description_en,image_url,image_urls,created_at')
          .eq('is_published', true).eq('topic', topic.value).not('slug', 'is', null)
          .order('created_at', {ascending:false}).order('id', {ascending:false}).limit(1)));
        if (!active || current !== request) return;
        const failed = results.find(result => result.error);
        if (failed) throw failed.error;
        setPosts(results.map(result => result.data?.[0] || null));
        setStatus("ready");
      } catch {
        if (active && current === request) setStatus("error");
      }
    }
    loadPosts();
    const unsubscribe = subscribeBlogUpdates(loadPosts);
    return () => { active = false; unsubscribe(); };
  }, []);

  return (
    <section className="latest-posts section__padding" aria-labelledby="latest-posts-heading">
      <div className="latest-posts__header">
        <div>
          <span className="latest-posts__eyebrow">{translate("home.blog.label")}</span>
          <h2 id="latest-posts-heading">{translate("home.blog.heading")}</h2>
          <p>{translate("home.blog.intro")}</p>
        </div>
        <Link className="custom__button latest-posts__browse" to="/blog">{translate("home.blog.browse")}</Link>
      </div>
      {status !== "ready" ? (
        <>
          <p role="status" className="latest-posts__status">{translate(status === "loading" ? "home.blog.loading" : status === "error" ? "home.blog.error" : "home.blog.empty")}</p>
          <div className="latest-posts__grid">
            {Array.from({ length: 4 }, (_, index) => (
              <div className="latest-posts__placeholder" key={index} data-testid="latest-posts-placeholder" aria-hidden="true">
                <div className="latest-posts__image"><span>KAVAK</span></div>
                <span className="latest-posts__placeholder-line" />
                <span className="latest-posts__placeholder-line" />
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="latest-posts__grid">
          {BLOG_TOPICS.map((topic, index) => {
            const post = posts[index];
            if (!post) return <article className="latest-posts__card" key={topic.value}><Link to={`/blog/${topic.slug}`}><div className="latest-posts__image"><span>KAVAK</span></div><strong className="blog-topic">{topic.value}</strong><p>{isFa ? "هنوز مقاله‌ای در این موضوع منتشر نشده است." : "No published article in this topic yet."}</p></Link></article>;
            const title = blogText(post, "title", language);
            const description = blogText(post, "description", language);
            const cover = blogImages(post)[0];
            return (
              <article className="latest-posts__card" key={post.id}>
                <Link to={blogPath(post)}>
                  <div className="latest-posts__image">
                    {cover ? <img src={cover} alt="" loading="lazy" /> : <span aria-hidden="true">KAVAK</span>}
                  </div>
                  <div className="latest-posts__meta">
                    <strong className="blog-topic">{topic.value}</strong>
                    {post.created_at && <time dateTime={post.created_at}>{new Date(post.created_at).toLocaleDateString(isFa ? "fa-IR" : "en-GB", { year: "numeric", month: "short", day: "numeric" })}</time>}
                  </div>
                  <h3>{title}</h3>
                  {description && <p className="latest-posts__excerpt">{blogExcerpt(description)}</p>}
                  <span className="latest-posts__read">{translate("home.read")} <span aria-hidden="true">{isFa ? "←" : "→"}</span></span>
                </Link>
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
}
